<template>
  <div class="form-card " shadow="never">
    <el-form ref="formRef" class="common-form" :inline="true" :model="localDataForm" @submit.prevent="query"
      v-bind="$attrs">
      <template v-for="itemConfig in props.formConfigs" :key="itemConfig.prop">
        <block v-if="!itemConfig.hidden">
          <slot v-if="itemConfig.slot" :name="itemConfig.slot" />
          <el-form-item v-else :prop="itemConfig.prop" :style="{ width: itemConfig.width, ...itemConfig?.style }"
            :label-width="itemConfig.labelWidth" :label="t(itemConfig.label)" :rules="itemConfig.rules">
            <component :is="getComponent(itemConfig)" v-model="localDataForm[itemConfig.prop as string]" v-bind="$attrs"
              :config="itemConfig" @change="dataChange" />
          </el-form-item>
        </block>
      </template>
      <el-form-item v-if="defaultQuery" class="ml-[10px]">
        <slot name="beforeFormButton">
          <el-button type="primary" @click="query" icon="Search">{{ $t("common.query") }}
          </el-button>
          <el-button class="reset" @click="reset" icon="Refresh">
            {{ $t("common.reset") }}
          </el-button>
          <el-button v-if="props.ifAdd" icon="Plus" plain type="primary" @click="$emit('onAdd')">
            {{ $t("common.add") }}</el-button>
        </slot>

        <!-- 扩展按钮 -->
        <slot name="formButton" />
      </el-form-item>
    </el-form>
    <slot name="slotBot" style="margin-left: 10px" />
  </div>
</template>
<script lang="ts" setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  formConfigs: {
    type: Array as () => FormItemConfig[],
    required: true,
  },
  dataForm: {
    type: Object,
    required: true,
  },
  ifAdd: {
    type: Boolean,
    default: false,
  },
  defaultQuery: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits<{
  (event: "update:dataForm", value: Record<string, any>): void;
  (event: "onAdd"): void;
  (event: "onDel"): void;
  (event: "onRead"): void;
  (event: "onQuery"): void;
  (event: "onReset"): void;
}>();

const { t } = useI18n();
const formRef = ref<any>(null);

const localDataForm = ref(props.dataForm);

watch(
  () => props.dataForm,
  (newDataForm) => {
    localDataForm.value = newDataForm;
  }
);

const validate = async (): Promise<boolean> => {
  try {
    await formRef.value.validate();
    return true;
  } catch (e) {
    return false;
  }
};

const resetForm = () => {
  formRef.value.resetFields();
};

const query = async () => {
  if (await validate()) {
    emit("onQuery");
  }
};

const reset = () => {
  localDataForm.value = {};
  resetForm();
  emit("update:dataForm", localDataForm.value);
  emit("onReset");
};

const dataChange = (info: { prop: string | number; value: any }) => {
  localDataForm.value[info.prop] = info.value;
};
defineExpose({
  validate,
  reset,
  query,
  resetForm,
});

const getComponent = (value: FormItemConfig): string => {
  const type = value.type;
  switch (type) {
    case "text":
      return "search-input";
    case "select":
      return "search-select";
    case "datetimerange":
    case "datetime":
    case "date":
    case "daterange":
    case "monthrange":
      return "search-date";
    default:
      if (value.componentName) {
        return value.componentName;
      }
      return "";
  }
};
</script>

<style lang="scss" scoped>
.form-card {
  box-sizing: border-box;
  width: 100%;
  min-height: 56px;
  // padding: 16px 16px 0;
  overflow: visible;

  .actions {
    display: inline-flex;
    align-items: center;
    height: 32px;
    margin-bottom: 16px;
  }

  :deep(.el-card__body) {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 16px 16px 0;
  }

  :deep(.el-form-item) {
    margin-bottom: 16px;
  }
}

:deep(.common-form) {
  .el-form-item:last-child {
    margin-right: 0;
  }

  .el-form-item {
    margin-right: 16px;

    &:not(:last-child) {
      width: 210px;
    }

    .el-form-item__content {
      margin-right: 20px;

      &>div,
      .el-input {
        width: 100%;
      }
    }
  }
}

@media screen and (width <=1440px) {
  :deep(.common-form) {
    .el-form-item {
      &:not(:last-child) {
        width: 160px;
      }
    }
  }
}

@media screen and (width <=640px) {
  :deep(.common-form) {
    .el-form-item {
      &:not(:last-child) {
        width: 100%;
      }
    }
  }
}
</style>
